<template>
  <div>
    <!-- CHECK-IN (AKA - ACTION REQUIRED) SUPPLIERS MODAL -->
    <b-modal
      id="checkIn-ess-info-modal"
      ref="checkIn-essential-sup-modal-ref"
      hide-footer
      title="Action Required"
      @hidden="resetModal"
      >
      <div v-if="checkInSuppliers.length > 0" role="tablist">
        <!-- EXPAND/COLLAPSE ALL BTN -->
        <div class="d-flex justify-content-end" role="tab">

          <b-button
            class="expand-collpase-btn"
            :class="{ 'item-active': dropDownExpandBtn }"
            id="expand-collapse"
            size="sm"
            @click="toggleExpandBtn(checkInSuppliers, 'cardImage')"
            >
            <div class="item-title">
              <span>Expand/Collapse All</span>
            </div>
            <div class="toggle-essential">
              <span v-if="dropDownExpandBtn">-</span>
              <span v-else>+</span>
            </div>
          </b-button>
        </div>

        <div v-for="(infoType, i) of checkInSuppliers" :key="infoType._id" class="item-container">
          <div v-for="(item, accordIndx) of checkInSuppliers[i].cardImage" :key="item._id">
            <div role="tab">
              <b-button
                v-if="infoType.suppliers.length > 0"
                class="accordion-btn"
                :class="{ 'item-active': activeAccordions.includes(item.tmpKey) }"
                :id="'buttonID-' + i"
                size="sm"
                @click="toggleExpandAccord(item.tmpKey)"
              >
                <div class="item-title">
                  <span>{{ item.title }}</span>
                </div>
                <div class="toggle-essential">
                  <span v-if="activeAccordions.includes(item.tmpKey)">-</span>
                  <span v-else>+</span>
                </div>
              </b-button>
            </div>

            <b-collapse
              v-if="infoType.suppliers.length > 0"
              :id="'cardImage' + accordIndx"
              :visible="activeAccordions.includes(item.tmpKey)"
              role="tabpanel">
              <div class="item-dropdown accordions">
                <div class="item-dropdown-main accordions-main">
                  <div class="extra-info-essentials">
                    <div>
                      <p v-html="item.content" @click="handleEssentialInfoClick"></p>
                    </div>
                    <div v-if="item.base64image" class="extra-info-img">
                      <img class="non-gallery-img" :src="item.base64image" alt="accordion image" />
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>

            <b-collapse id="checkInCard" role="tabpanel">
              <div class="item-dropdown accordions">
                <div class="item-dropdown-main accordions-main">
                  <div class="extra-info-essentials">
                    <div>
                      <p v-html="item.content"></p>
                    </div>
                    <div v-if="item.base64image" class="extra-info-img">
                      <img class="non-gallery-img" :src="item.base64image" alt="accordion image" />
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- VOUCHER SUPPLIERS MODAL -->
    <b-modal
      id="voucher-ess-info-modal"
      ref="voucher-essential-sup-modal-ref"
      hide-footer
      title="Voucher Information"
      @hidden="resetModal"
      >
      <div v-if="voucherSuppliers.length > 0" role="tablist">
        <!-- EXPAND/COLLAPSE ALL BTN -->
        <div class="d-flex justify-content-end" role="tab">
          <b-button
            class="expand-collpase-btn"
            :class="{ 'item-active': dropDownExpandBtn }"
            id="expand-collapse"
            size="sm"
            @click="toggleExpandBtn(voucherSuppliers, 'cardImage')"
            >
            <div class="item-title">
              <span>Expand/Collapse All</span>
            </div>
            <div class="toggle-essential">
              <span v-if="dropDownExpandBtn">-</span>
              <span v-else>+</span>
            </div>
          </b-button>
        </div>

        <div v-for="(infoType, i) of voucherSuppliers" :key="infoType._id" class="item-container">
          <div v-for="item of voucherSuppliers[i].cardImage" :key="item._id">
            <div role="tab">
              <b-button
                v-if="infoType.suppliers.length > 0"
                class="accordion-btn"
                :class="{ 'item-active': activeAccordions.includes(item.tmpKey) }"
                :id="'buttonID-' + i"
                size="sm"
                @click="toggleExpandAccord(item.tmpKey)"
                >
                <div class="item-title">
                  <span>{{ item.title }}</span>
                </div>
                <div class="toggle-essential">
                  <span v-if="activeAccordions.includes(item.tmpKey)">-</span>
                  <span v-else>+</span>
                </div>
              </b-button>
            </div>

            <b-collapse id="voucherCard" role="tabpanel" :visible="activeAccordions.includes(item.tmpKey)">
              <div class="item-dropdown accordions">
                <div class="item-dropdown-main accordions-main">
                  <div class="extra-info-essentials">
                    <div>
                      <p v-html="item.content"></p>
                    </div>
                    <div v-if="item.base64image" class="extra-info-img">
                      <img class="non-gallery-img" :src="item.base64image" alt="accordion image" />
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- PRODUCT SUPPLIERS MODAL -->
    <b-modal
      id="product-ess-info-modal"
      ref="product-essential-sup-modal-ref"
      hide-footer
      @hidden="resetModal"
      :title="title">
      <div v-if="productSuppliers.length > 0" role="tablist">
        <!-- Expand/Collapse Btn -->
        <b-row>
          <b-col v-if="hasTPTSuppliers && productSuppliers.length > 1" class="tpt-header-container">
            <h4 class="tpt-header mb-3">{{ item.operator }}</h4>
          </b-col>
          <b-col class="d-flex justify-content-end" role="tab">
            <b-button
              class="expand-collpase-btn"
              :class="{ 'item-active': dropDownExpandBtn }"
              id="expand-collapse"
              size="sm"
              @click="toggleExpandBtn(productSuppliers, 'accordions')"
              >
              <div class="item-title">
                <span>Expand/Collapse All</span>
              </div>
              <div class="toggle-essential">
                <span v-if="dropDownExpandBtn">-</span>
                <span v-else>+</span>
              </div>
            </b-button>
          </b-col>
        </b-row>
        <!-- /// Has TPT Suppliers AND Multiple Product Records created in KB Essen Info /// -->
        <div v-if="hasTPTSuppliers && productSuppliers.length > 1">
          <div v-for="(infoType, i) of productSuppliers" :key="infoType._id" class="item-container">
            <!-- Parent TPT Accordion Btn -->
            <div role="tab">
              <b-button
                class="accordion-btn"
                :class="{ 'item-active': activeAccordions.includes(`parent-${i}`) }"
                :id="'parentBtnID-' + infoType._id"
                size="sm"
                @click="toggleExpandAccord(`parent-${i}`)"
                >
                <div class="item-title">
                  <span>{{ formatTPTSupplierName(infoType.suppliers) }}</span>
                </div>
                <div class="toggle-essential">
                  <span v-if="activeAccordions.includes(`parent-${i}`)">-</span>
                  <span v-else>+</span>
                </div>
              </b-button>
            </div>

            <!-- Child Accordion Btn -->
            <b-collapse
              :id="'tpt-supplier' + infoType._id"
              role="tabpanel"
              :visible="activeAccordions.includes(`parent-${i}`)"
              >
              <div v-for="item of productSuppliers[i].accordions" :key="item._id">
                <div role="tab">
                  <b-button
                    class="accordion-btn"
                    :class="{ 'item-active': activeAccordions.includes(item.tmpKey) }"
                    :id="'childBtnID-' + infoType._id"
                    size="sm"
                    @click="toggleExpandAccord(item.tmpKey)"
                    :visible="activeAccordions.includes(item.tmpKey) && activeAccordions.includes(`parent-${i}`)"
                    >
                    <div class="item-title">
                      <span>{{ item.title }}</span>
                    </div>
                    <div class="toggle-essential">
                      <span
                        v-if="activeAccordions.includes(item.tmpKey)"
                        >-</span
                      >
                      <span v-else>+</span>
                    </div>
                  </b-button>
                </div>

                <!-- Child Accordion Instance -->
                <b-collapse
                  :id="'product-supplier' + item._id"
               
                  role="tabpanel"
                  :visible="activeAccordions.includes(item.tmpKey) && activeAccordions.includes(`parent-${i}`)"
                  >
                  <div class="item-dropdown accordions">
                    <div class="item-dropdown-main accordions-main">
                      <div class="extra-info-essentials">
                        <div>
                          <p v-html="item.content"></p>
                        </div>
                        <div v-if="item.base64image" class="extra-info-img">
                          <img
                            class="non-gallery-img"
                            :src="item.base64image"
                            alt="accordion image" />
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </b-collapse>
          </div>
        </div>

        <!-- /// NO TPT Suppliers AND/OR Only 1 TPT Product Record created in KB Essen Info /// -->
        <div v-else>
          <div v-for="(infoType, i) of productSuppliers" :key="infoType._id" class="item-container">
            <div v-for="(item) of productSuppliers[i].accordions" :key="item._id">
              <div role="tab">
                <b-button
                  v-if="infoType.suppliers.length > 0"
                  class="accordion-btn"
                  :class="{ 'item-active': activeAccordions.includes(item.tmpKey) }"
                  :id="'buttonID-' + infoType._id"
                  size="sm"
                  @click="toggleExpandAccord(item.tmpKey)"
                  >
                  <div class="item-title">
                    <span>{{ item.title }}</span>
                  </div>
                  <div class="toggle-essential">
                    <span v-if="activeAccordions.includes(item.tmpKey)">-</span>
                    <span v-else>+</span>
                  </div>
                </b-button>
              </div>

              <b-collapse
                v-if="infoType.suppliers.length > 0"
                :id="'product-supplier' + item._id"
                :visible="activeAccordions.includes(item.tmpKey)"
                role="tabpanel">
                <div class="item-dropdown accordions">
                  <div class="item-dropdown-main accordions-main">
                    <div class="extra-info-essentials">
                      <div>
                        <p v-html="item.content"></p>
                      </div>
                      <div v-if="item.base64image" class="extra-info-img">
                        <img
                          class="non-gallery-img"
                          :src="item.base64image"
                          alt="accordion image" />
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {
  fetchSupplierRecord,
  fetchCheckInRecord,
  fetchDestinationRecord,
  fetchVoucherRecord,
} from './services'
import { mapGetters } from 'vuex'

export default {
  props: {
    item: null,
  },
  data() {
    return {
      dropDownExpandBtn: false,
      activeAccordions: [],
      expandBtnClicked: false,
      productSuppliers: [],
      productDestinations: [],
      checkInSuppliers: [],
      voucherSuppliers: [],
    }
  },
  async created() {
    if (this.item.essentialInformation) {
      if (this.item.essentialInformation.checkInEssential.length > 0) {
        for (let i = 0; i < this.item.essentialInformation.checkInEssential.length; i++) {
          const element = this.item.essentialInformation.checkInEssential[i]
          if (element.suppliers) {
            const sup = await fetchCheckInRecord(element._id, this.sessionNum)
            if (sup && sup.cardImage && sup.cardImage.length) {
              sup.cardImage = sup.cardImage.map((card,j) => {
                card.tmpKey = `chk-${i}-${j}`
                if (!card._id) {
                  card._id = `chk-${i}-${j}`
                }
                return card
              })
            }
            this.checkInSuppliers.push({ ...sup })
          }
        }
      }
      if (this.item.essentialInformation.voucherEssential.length > 0) {
        for (let i = 0; i < this.item.essentialInformation.voucherEssential.length; i++) {
          const element = this.item.essentialInformation.voucherEssential[i]
          if (element.suppliers) {
            const sup = await fetchVoucherRecord(element._id, this.sessionNum)
            if (sup && sup.cardImage && sup.cardImage.length) {
              sup.cardImage = sup.cardImage.map((card,j) => {
                card.tmpKey = `vcr-${i}-${j}`
                if (!card._id) {
                  card._id = `vcr-${i}-${j}`
                }
                return card
              })
            }
            this.voucherSuppliers.push({ ...sup })
          }
        }
      }
      if (this.item.essentialInformation.productEssential.length > 0) {
        for (let i = 0; i < this.item.essentialInformation.productEssential.length; i++) {
          const element = this.item.essentialInformation.productEssential[i]
          if (element.suppliers) {
            const sup = await fetchSupplierRecord(element._id, this.sessionNum)
            if (sup && sup.accordions && sup.accordions.length) {
              sup.accordions = sup.accordions.map((acc,j) => {
                acc.tmpKey = `sup-${i}-${j}`
                if (!acc._id) {
                  acc._id = `sup-${i}-${j}`
                }
                return acc
              })
            }
            this.productSuppliers.push({ ...sup })
          }
          if (element.destinations) {
            const des = await fetchDestinationRecord(element._id, this.sessionNum)
            if (des && des.accordions && des.accordions.length) {
              des.accordions = des.accordions.map((acc,j) => {
                acc.tmpKey = `des-${i}-${j}`
                if (!acc._id) {
                  acc._id = `des-${i}-${j}`
                }
                return acc
              })
            }
            this.productDestinations.push({ ...des })
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({ sessionNum: 'booking/getSessionID' }),
    title() {
      if (this.item.tourtype === 'CRUISE') {
        return `Essential Cruise Information`
      }
      return `
        Essential
        ${this.item.jsontype.charAt(0).toUpperCase() + this.item.jsontype.slice(1)}
        Information
      `
    },
    hasTPTSuppliers() {
      return this.item.tptsupps && this.item.tptsupps.length > 1 && this.item.tptsupps[0] !== ''
        ? true
        : false
    },
  },
  methods: {
    formatTPTSupplierName(suppliers) {
      if (suppliers.length > 1) {
        const multipleNames = suppliers
          .map((s) => s.name.split('(')[0])
          .slice()
          .join(', ')
        return multipleNames
      }
      const [suppName] = suppliers.map((s) => s.name.split('(')[0])
      return suppName
    },
    // Toggle Expand/Collapse for all other Modals
    toggleExpandBtn(suppArr, nestedKey) {
      this.expandBtnClicked = !this.expandBtnClicked
      this.dropDownExpandBtn = !this.dropDownExpandBtn
      const accordionKeys = []
      if (suppArr && suppArr.length && nestedKey) {
        if (this.expandBtnClicked) {
          suppArr.forEach((item, i) => {
            accordionKeys.push(`parent-${i}`) // where there are multiple product suppliers, we need to track which parent accordions are opened
            if (item && item[nestedKey]) {
              item[nestedKey].forEach((nestedItem) => {
                accordionKeys.push(nestedItem.tmpKey)
              })
            }
          })
        } // else assign as an empty array to close accordions
        this.activeAccordions = accordionKeys
      }
    },
    // General Accordion Toggle for rest of Modals
    toggleExpandAccord(key) {
      let arr = [...this.activeAccordions]
      if (arr.includes(key)) {
        arr = arr.filter(active => active !== key)
      } else {
        arr = [...arr, key]
      }
        this.activeAccordions = arr
    },

    showCheckInSup() {
      this.setFirstAccordionKey(this.checkInSuppliers, 'cardImage')
      this.$refs['checkIn-essential-sup-modal-ref'].show()
    },
    showVoucherSup() {
      this.setFirstAccordionKey(this.voucherSuppliers, 'cardImage');
      this.$refs['voucher-essential-sup-modal-ref'].show();
    },
    showProductSup() {
      this.setFirstAccordionKey(this.productSuppliers, 'accordions')
      this.$refs['product-essential-sup-modal-ref'].show()
    },
    setFirstAccordionKey(mainArr, subArrKey) {
      if (mainArr && mainArr[0] && mainArr[0][subArrKey] && mainArr[0][subArrKey][0] && mainArr[0][subArrKey][0].tmpKey) {
        this.activeAccordions = [mainArr[0][subArrKey][0].tmpKey] // forces the first accordion open upon the modal opening
      }
    },
    handleEssentialInfoClick(event) {
      if (event.target && event.target.classList.contains('essential-info-link')) {
        event.preventDefault()
        this.showProductSup()
      }
    },
    resetModal() {
      this.dropDownExpandBtn = false
      this.expandBtnClicked = false
      this.activeAccordions = [] 
    },
  },
}
</script>

<style lang="scss">
.tpt-header-container {
  display: flex;
  justify-content: center;
}
.expand-collpase-btn {
  color: rgb(33, 37, 41);
  background-color: #f5f5f5;
  padding: 0.4rem 0.9rem !important;
}
.accordion-btn {
  display: grid;
  grid-template-columns: 13fr 1fr;
  width: 100%;
  color: rgb(33, 37, 41);
  background-color: #f5f5f5;
  margin: 10px 0;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-left: 3px solid #76c95f00;
}
.essential-info-link {
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.toggle-essential {
  cursor: pointer;
  font-size: 30px;
  align-self: center;
}

@media only screen and (min-width: 700px) {
  .tpt-header-container {
    justify-content: start;
  }
  .tpt-header {
    align-self: flex-end;
  }
  .expand-collpase-btn {
    padding: 0rem 0.5rem !important;
  }
}
</style>
